export const FontStyles = {
    heading1: {
        color: "#c18e3d",
        margin: 0,
        fontSize: "28px",
        lineHeight: 1.57,
        fontFamily: '"Inter var"',
        // color: "rgb(91, 107, 121)",
        fontWeight: 400,

    },
    aboutText: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: "16px",//"24px"
        lineHeight: "34px",
        letterSpacing: "0%",
        textAlign: "justify",
        marginBottom: "10px",
        padding: "10px"
    },
    faqcontent: {
        flex: "1",
        textAlign: "start",
        fontFamily: '"Inter var"',
        fontWeight: "bold",
        fontSize: "24px",
    },
    faqphg: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "34px",
        letterSpacing: "0%",
        textAlign: "justify",
        marginBottom: "10px",
        padding: "10px"
    },
    careerkeypoints: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "24px",
        letterSpacing: "0%",
        textAlign: "justify",

        marginBottom: "10px",
        marginLeft: { xs: "0px", md: "20px" }
    },
    contactText: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "100%",
        letterSpacing: "0%",
    },
    citynameContactDetalies: {
        fontFamily: '"Inter var"',
        fontWeight: { xs: 400, md: 700 },
        fontSize: { xs: '15px', md: '18px' },
        lineHeight: "100%",
        letterSpacing: "0%",
    },
    contactcitylabeldesign: {
        position: 'absolute',
        top: -25,
        right: -25,
        backgroundColor: '#009688',
        color: ' #fff;',
        height: "50px",
        px: 2,
        py: 0.5,
        fontWeight: 'medium',
        borderRadius: '4px',
        fontSize: "14px",
        boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
        clipPath: "polygon(0% 0%, 80% 0%, 100% 0%, 100% 75%, 50% 100%, 0% 75%, 0% 0%)"
    },
    mapdesignforcontact: {
        width: "100%",
        height: 200,
        border: "2px solid #ccc",
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflowWrap: "anywhere",
        backgroundColor: "#f5f5f5",
        fontSize: "14px",
        textAlign: "center",
        p: 1,
    },
    faqfontstyle: {
        fontFamily: '"Inter var"',
        fontWeight: 600,
        fontSize: '24px'
    },
    DemoVideobottomText: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: "22px",
        color: "rgba(199, 15, 15, 0.77)"
    },
    FooterLINKtext: {
        color: "white",
        cursor: "pointer",
        mb: 1,
        fontFamily: '"Inter var"',
        fontSize: "18px", fontWeight: 600,
        "&:hover": { color: "#C1721F" },
    },
    FooterCommontext: {
        color: "white",
        mb: 1,
        display: "flex",
        alignItems: "center",
        fontSize: "18px",
        fontFamily: '"Inter var"',
        fontWeight: 600,
    },
    headrmyAccountFont: {
        color: "black", fontWeight: 700, 
        fontSize: { xs: "18px", sm: "18px", md: "18px", },
        fontFamily: '"Inter var"',

    },
    profilename: {
        fontFamily: '"Inter var"',
        fontWeight: 600,
        color: "#C63D0F",
        marginTop: "10px",
        textAlign: "start",
        marginBottom: 0,
        marginTop: "-9px",
        fontSize: { xs: "20px", sm: "22px", md: "25px", },//xl: "20px", lg: "34px", xxl: "50px" 

    },
    profilenameforcard: {
        fontFamily: '"Inter var"',
        fontWeight: 600,
        color: "#C63D0F",
        marginTop: "10px",
        textAlign: "start",
        marginBottom: 0,
        marginTop: "-9px",
        fontSize: { xs: "20px", sm: "22px", md: "18px", },//xl: "16px", lg: "34px", xxl: "50px" 

    },
    displayText: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: { xs: "18px", sm: "18px", md: "18px",},// xl: "16px", lg: "18px", xxl: "30px" 
        margin: "10px 0",
        textAlign: "start",
    },
    profileId: {
        backgroundColor: "#c1721f",
        color: "white",
        textAlign: "start",
        padding: { xs: "8px 12px", sm: "10px 20px" },
        fontSize: { xs: "18px", sm: "18px", md: "18px", lg: "18px", xl: "16px", xxl: "30px" },
        width: { xs: "100%", sm: "auto" },
        fontFamily: '"Inter var"',
        "&:hover": {
            backgroundColor: "#c1721f",
            color: "white",
        },
    },
    accept: {
        backgroundColor: "#1C881C",
        color: "white",
        padding: { xs: "8px 12px", sm: "10px 20px" },
        fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "16px", lg: "18px", xxl: "30px" },
    },
    ignore: {
        backgroundColor: "#C63D0F",
        color: "white",
        padding: { xs: "8px 12px", sm: "10px 20px" },
        fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "16px", lg: "18px", xxl: "30px" },
    },
    filtertext: {
        width: { xs: "100%", sm: "257px" },
        padding: '10px',
        border: '1px solid #eee',
        height: '44px',
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: '"Inter var"',
        fontWeight: 700,
        fontSize: '16px',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.3s, color 0.3s',
    },
    paytext: {
        fontSize: { xs: "13px", sm: "20px", xxl: "40px" },
        fontWeight: 500,
        color: "#333",
        mb: { xs: 1, sm: 1.5 },
        fontFamily: '"Inter var"',

    },
    payButton: {
        backgroundColor: "#c1721f",
        color: "white",
        padding: "10px",
        fontFamily: '"Inter var"',

        // fontSize: { xs: "13px", sm: "16px", },
        fontSize: { xs: "18px", sm: "18px", xxl: "30px" },
        "&:hover": { backgroundColor: "#8E5723" },
        borderRadius: "20px"
    },
    invoiceButton: {
        backgroundColor: "#c1721f",
        color: "white",
        px: 2,
        width: { xs: "100%", sm: "auto", xl: "auto", xxl: "350px" },
        height: { xs: "45.18px", sm: "40px", xl: "40px", xxl: "80px" },
        fontFamily: '"Inter var"',
        fontWeight: 500,
        fontSize: { xs: "18px", sm: "16px", xxl: "40px" },
        lineHeight: "100%",
        letterSpacing: "0%",
        padding: { sm: "10px" },
        "&:hover": { backgroundColor: "#8E5723" },
    },
    viewandeditButton: {
        backgroundColor: "#c1721f",
        color: "white",
        padding: { sm: "10px" },
        width: { xs: "100%", sm: "auto", xxl: "300px" },
        height: { xs: "45.18px", sm: "40px", xxl: "80px" },
        fontFamily: '"Inter var"',
        fontWeight: 500,
        // fontSize: "18px",
        fontSize: { xs: "18px", sm: "16px", xxl: "40px" },
        lineHeight: "100%",
        letterSpacing: "0%",
        "&:hover": { backgroundColor: "#8E5723" },
    },
    incomming: {
        backgroundColor: "green",
        color: "white",
        minWidth: "100px",
        minHeight: "40px",
        fontSize: { xs: "12px", sm: "14px", xxl: "35px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: '"Inter var"',
        "&:hover": { backgroundColor: "darkgreen" },
        mb: { xxl: 2 },

    },
    planButton: {
        backgroundColor: "green",
        color: "white",
        px: 2,
        minWidth: "40px",
        minHeight: "40px",
        fontSize: { xs: "12px", sm: "14px", xxl: "35px" },
        "&:hover": { backgroundColor: "darkgreen" },
        mb: { xxl: 2 },
        fontFamily: '"Inter var"',

    },
    cardid: {
        fontSize: { xs: "14px", sm: "20px", xxl: "40px" },
        color: "#444",
        fontWeight: "bold",
        fontFamily: '"Inter var"',
    },
    cardplanbutton: {

        backgroundColor: "#006400",
        color: "white",
        px: 2,
        fontFamily: '"SF Pro Display", sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        // width: { xs: "25px", sm: "25px" },
        wisth: "auto",
        height: { xs: "25px", sm: "35px" },
        lineHeight: '100%',
        marginLeft: { xs: "110px", sm: "0px" },
        justifyContent: { xs: "center" },
        alignItems: { xs: "center" },
        letterSpacing: '0%',
        "&:hover": { backgroundColor: "#006400" },
    },
    profilenamedrop: {
        fontFamily: '"Inter var"',
        fontWeight: 700,
        fontSize: { xs: "20px", sm: "22px", md: "34px", xl: "34px", lg: "34px", xxl: "50px" },
        lineHeight: "100%",
        mb: { xs: 0.5, sm: 2, xxl: 3 },
    },
    addphotoTEXt: {
        margin: '0px', color: 'white', backgroundColor: "#C1721F", padding: '10px', marginBottom: '10px',
        fontFamily: '"Inter var"',

    },
    razorpay: {
        fontSize: { xs: '16px', sm: '20px', xxl: "30px" }, color: "#c1721f",
        fontFamily: '"Inter var"',

    },
    paybutton: {
        backgroundColor: "#c1721f",
        color: "#ffff",
        fontWeight: "bold",
        padding: "10px",
        borderRadius: "20px",
        marginTop: "10px",
        textTransform: "none",
        fontSize: { sm: "15px", xxl: "30px" },
        "&:hover": {
            backgroundColor: "#e5d6b5",
            color: "#000000",
        },
    },
    onlyTelugu: {
        color: "#c77c2f",
        fontWeight: "700",
        fontFamily: '"Inter var"',
        whiteSpace: { xs: "normal", sm: "nowrap" },
        fontSize: { xs: "16px", sm: "20px", md: "36px" },
        letterSpacing: "2px",
        marginTop: { sm: "70px" },
        textAlign: "center",

    },
    anywhre: {
        color: "#c77c2f",
        fontWeight: "700",
        whiteSpace: { xs: "normal", sm: "nowrap" },
        fontFamily: '"Inter var"',
        letterSpacing: "0px",
        fontSize: { xs: "13px", sm: "15px", md: "24px" },
    },
    findyour: {
        color: "#c77c2f",
        fontWeight: "700",
        whiteSpace: { xs: "normal", sm: "nowrap" },
        fontFamily: '"Inter var"',
        fontSize: { xs: "16px", sm: "20px", md: "34px" },
        marginTop: { xs: "10px", sm: "20px" },
        letterSpacing: "2px",
        textAlign: "center",
    },
    partner: {
        color: "#c77c2f",
        fontWeight: "700",
        fontFamily: '"Inter var"',
        whiteSpace: { xs: "normal", sm: "nowrap" },
        fontSize: { xs: "13px", sm: "15px", md: "24px" },
        letterSpacing: "5px"
    },
    cmdText: {
        fontFamily: '"Inter var"',
        fontWeight: 400,
        fontSize: '16px',//20px
        lineHeight: '30px',
        letterSpacing: '0%',
        textAlign: "start"
    },
    FeedBack: {
        fontFamily: '"Inter var"',
        fontWeight: 700,
        fontSize: '20px',//'28px'
        lineHeight: '150%',
        letterSpacing: '0%',
        color: "#C1721F"
    },
    FontStyleforCmd: {
        fontSize: "20px",//25px
        fontFamily: '"Inter var"',
        fontWeight: 700
    },
    aboutSpan: {
        fontFamily: '"Inter var"',
        fontWeight: 700,
        fontSize: "18px",
        lineHeight: "34px",
        letterSpacing: "0%",
        textAlign: "justify",
    },
    vrefiedSerach: {
        backgroundColor: "#C1721F",
        color: "white",
        borderRadius: "40px",
        width: "120px",
        height: "42px",
        fontFamily: '"Inter var"',
        padding: { xs: "8px 12px", sm: "10px 4px" },
        fontSize: { xs: "12px", sm: "18px" },
    },
    verfiedPersaonal: {
        fontSize: "20px",//25px
        fontFamily: '"Inter var"',
        fontWeight: 700

    }
}